import { RouteObject } from 'react-router'

import { PLATFORM } from '@/constants/platform'
import { STREAMING_MENU_ICONS } from '@/router/icons'
import { PageUnderConstruction } from '@/views/PageUnderConstruction'

export const dashboardRoutes: RouteObject[] = [
  {
    path: 'dashboard',
    label: 'Dashboard',
    icon: STREAMING_MENU_ICONS.DASHBOARD,
    platforms: [PLATFORM.DGE],
    children: [
      {
        index: true,
        element: <PageUnderConstruction />,
        platforms: [PLATFORM.DGE]
      }
    ]
  }
]
